import { render, staticRenderFns } from "./ContainersStatistics.vue?vue&type=template&id=3a385a2c"
import script from "./ContainersStatistics.vue?vue&type=script&lang=js"
export * from "./ContainersStatistics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports